import React from 'react'
import { async, Updater, Widget } from 'widgets-for-react'
import { notFoundWidget } from '../notFound/notFoundWidget'
import { CmsPageState, cmsPageStateUpdaters, Page } from './cmsPageState'
import { centrumPageWidget } from './page/centrumPage/centrumPageWidget'
import { departmentPageWidget } from './page/departmentPage/departmentPageWidget'
import { eventPageWidget } from './page/eventPage/eventPageWidget'
import { dossierPageWidget } from './page/dossierPage/dossierPageWidget'
import { folderPageWidget } from './page/folderPage/folderPageWidget'
import { friendPageWidget } from './page/friendPage/friendPageWidget'
import { homePageWidget } from './page/homePage/homePageWidget'
import { locationPageWidget } from './page/locationPage/locationPageWidget'
import { newsPageWidget } from './page/newsPage/newsPageWidget'
import { researchPageWidget } from './page/researchPage/researchPageWidget'
import { spaarnePageWidget } from './page/spaarnePage/spaarnePageWidget'
import { specialistPageWidget } from './page/specialistPage/specialistPageWidget'
import { subcentraPageWidget } from './page/subcentraPage/subcentraPageWidget'
import { subdepartmentPageWidget } from './page/subdepartmentPage/subdepartmentPageWidget'
import { waitingTimesPageWidget } from './page/waitingTimesPages/waitingTimesPageWidget'

export const cmsPageWidget = (acceptVideoCookie: () => void, navigationItems: string[], department?: string) => (state: CmsPageState) =>
  state.pageState.kind === 'failed'
    ? notFoundWidget(state.notFoundState).map(cmsPageStateUpdaters.notFoundStateUpdater)
    : async<Page>(state.pageState, page => pageSwitch(acceptVideoCookie, navigationItems)(page)
      .map(cmsPageStateUpdaters.pageUpdater))
      .map(cmsPageStateUpdaters.pageStateUpdater)

const pageSwitch =
  (acceptVideoCookie: () => void, navigationItems: string[]) =>
  (page: Page): Widget<Updater<Page>> => {
    switch (page.kind) {
      case 'home':
        return homePageWidget(acceptVideoCookie)(page)
      case 'spaarne':
        return spaarnePageWidget(acceptVideoCookie)(page)
      case 'friend':
        return friendPageWidget(acceptVideoCookie)(page)
      case 'friendHome':
        return friendPageWidget(acceptVideoCookie)(page)
      case 'centrum':
        return centrumPageWidget(acceptVideoCookie)(page)
      case 'subcentra':
        return subcentraPageWidget(acceptVideoCookie)(page)
      case 'department':
        return departmentPageWidget(acceptVideoCookie, navigationItems)(page)
      case 'subdepartment':
        return subdepartmentPageWidget(acceptVideoCookie)(page)
      case 'event':
        return eventPageWidget(acceptVideoCookie)(page)
      case 'news':
        return newsPageWidget(acceptVideoCookie)(page)
      case 'specialist':
        return specialistPageWidget(acceptVideoCookie)(page)
      case 'location':
        return locationPageWidget(acceptVideoCookie)(page)
      case 'waitingTimes':
        return waitingTimesPageWidget(acceptVideoCookie)(page)
      case 'research':
        return researchPageWidget(acceptVideoCookie)(page)
      case 'folderPage':
        return folderPageWidget(acceptVideoCookie)(page)
      case 'dossierPage':
        return dossierPageWidget(acceptVideoCookie)(page)
    }
  }
